import { Typography } from "antd"

const { Title, Paragraph } = Typography

export const WhoWeAre: React.FC = () => {
    return (
        <section className="who-we-are">
            <div className="who-we-are__card">
                <div className="who-we-are__card__content">
                    <div className="who-we-are__card__content__icon-wrapper">
                        <img src="/images/who-we-are-1.png" alt="who-we-are-1" />
                    </div>
                    <Title level={3} className="who-we-are__card__content__title">
                        Who We Are
                    </Title>
                    <Paragraph className="who-we-are__card__content__description">
                        Moodra was born from our own journey of self-discovery. Like you, we’ve searched for meaning, questioned our paths,
                        and wondered if there’s more to life. Overwhelmed by generic advice, we created Moodra — a personalized, science-backed
                        tool to help you uncover limiting beliefs and guide you toward a career that feels authentically yours. Our mission is simple:
                        to help you see yourself clearly, trust your path, and take charge of your story. Self-discovery shouldn’t be exhausting — it should be
                        liberating, empowering, and even a little fun.
                    </Paragraph>
                </div>
            </div>
            <div className="who-we-are__card">
                <div className="who-we-are__card__content">
                    <div className="who-we-are__card__content__icon-wrapper">
                        <img src="/images/who-we-are-2.png" alt="who-we-are-1" />
                    </div>
                    <Title level={3} className="who-we-are__card__content__title">
                        What We Do
                    </Title>
                    <Paragraph className="who-we-are__card__content__description">
                        We all grow up absorbing beliefs — about success, our capabilities, and the life we "should" live.
                        But not all of these beliefs serve us. At Moodra, we help you break free from limiting beliefs through
                        a science-backed self-assessment that explores your subconscious beliefs, personality, values, and more.
                        We then provide a personalized roadmap to help you align your life with what truly matters. When you see yourself clearly,
                        everything changes.
                    </Paragraph>
                </div>
            </div>
            <div className="who-we-are__card">
                <div className="who-we-are__card__content">
                    <div className="who-we-are__card__content__icon-wrapper">
                        <img src="/images/who-we-are-3.png" alt="who-we-are-1" />
                    </div>
                    <Title level={3} className="who-we-are__card__content__title">
                        How We Do
                    </Title>
                    <Paragraph className="who-we-are__card__content__description">
                        This isn’t just another personality quiz. It’s a comprehensive self-assessment combining psychology,
                        behavioral science, and career guidance. Our framework integrates MBTI, cognitive behavioral therapy,
                        and proprietary algorithms to analyze over 50 data points, revealing your inner strengths and external potential.
                        But insight alone isn’t enough — so we provide personalized learning modules and gamification features like progress
                        tracking and interactive challenges to keep you engaged. At Moodra, we don’t just help you find clarity. We help you make it real.
                    </Paragraph>
                </div>
            </div>
        </section>
    )
}